<template>
  <div class="block">
    <kst-number-with-date view-mode
      :catalog="Catalog"
      :data="recPayData"
      dateField="Date"
      numberField="PayNumber"
    />

    <template v-if="recPayData.ClientID">
      <kst-output field="ClientID" :data="recPayData" :catalog="Catalog">
        <template #left>
          <kst-output addons floating-label
            field="ClientAlias" :data="recPayData" :catalog="Catalog"
          />
        </template>
        <template #default>
          <kst-output addons expanded floating-label
            field="ClientName" :data="recPayData" :catalog="Catalog"
          />
        </template>
      </kst-output>
    </template>
    <template v-else>
      <kst-output control-off field="ClientID" :data="recPayData" :catalog="Catalog">
        <kst-output addons expanded floating-label
          field="ClientName" :data="recPayData" :catalog="Catalog"
        />
      </kst-output>
    </template>

    <kst-output field="PaymentTypeName" :data="recPayData" :catalog="Catalog"/>
    <kst-output field="PaymentValue" :data="recPayData" :catalog="Catalog"/>
    <kst-output field="Comment" :data="recPayData" :catalog="Catalog"/>
    <kst-output field="StatusID" :data="recPayData" :catalog="Catalog"/>
    <kst-created :data="recPayData"/>
    <kst-output field="WarehouseID" :data="recPayData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RcpyCatalog.js";

export default {
  props: {
    recPayData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>